import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('applicationsGrid');

    return {
        LAST_ACTIVITY: t('lastActivity'),
        LAST_EDITED: t('lastEdited'),
        LOADING: t('loading'),
        NAME: t('name'),
        NO_APPLICATIONS: t('noApplications'),
        NO_MORE_APPLICATIONS: t('noMoreApplications'),
        STATUS: t('status')
    };
};

export default useTranslation;
